const Unauthorized = () => (
  <div style={{ padding: "60px", textAlign: "center" }}>
    <h1>Free Trial Expired</h1>
    <p>Your free trial has ended. Please <a href="/contact">contact</a> the administration to continue using the service.</p>
    <p>Email: <a href="mailto:resirent@resirent.org">resirent@resirent.org</a></p>
  </div>
);

export default Unauthorized;
